import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'dialog-deactive',
    templateUrl: './dialog-deactive.component.html',
    styleUrls: ['./dialog-deactive.component.scss'],
    standalone: false
})
export class DialogDeactiveComponent {

  mainForm = new FormGroup({
    reason: new FormControl(null, Validators.required),
  });

  constructor(protected ref: NbDialogRef<DialogDeactiveComponent>) {
  }

  cancel() {
    this.ref.close();
  }

  save(name) {
    this.ref.close(name);
  }
}
